<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <app-card [cardOptionBtnValue]="'global.add_btn_text'|translate " [cardOptionBtnIcon]="'feather icon-plus'" [cardOptionBtn]="true" [cardRouterLink]="'/back-office/terms/add'" [title]="'global.overview'|translate">
        <app-grid [grid]="grid"></app-grid>
      </app-card>
    </div>
  </div>
</div>
